export const FileSizes = {
    kbyte: 1024,
    maxkbinbyte: 1048576
};
